import { ArrowRight } from "lucide-react";
import { siteContent } from "@/data/siteContent";

export const HomeShakthiSection = () => {
  const { homeShakthi } = siteContent;

  return (
    <section className="start-here-band" aria-labelledby="home-shakthi-title" data-testid="home-shakthi-section">
      <div className="site-container home-shakthi-layout">
        <div>
          <p className="section-kicker" data-testid="home-shakthi-kicker">{homeShakthi.kicker}</p>
          <h2 id="home-shakthi-title" className="section-title" data-testid="home-shakthi-title">{homeShakthi.heading}</h2>
          <div className="home-shakthi-copy" data-testid="home-shakthi-copy">
            {homeShakthi.copy.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
          </div>
        </div>
        <div className="start-here-aside" data-testid="home-shakthi-aside">
          <strong data-testid="home-shakthi-principle">{homeShakthi.principle}</strong>
          <a className="primary-link" href={homeShakthi.cta.destination} data-testid="home-shakthi-cta">
            {homeShakthi.cta.label} <ArrowRight size={17} aria-hidden="true" />
          </a>
        </div>
      </div>
    </section>
  );
};

export const FinalInvitationSection = () => {
  const { finalInvitation } = siteContent;

  return (
    <section className="final-invitation" aria-labelledby="final-title" data-testid="final-invitation-section">
      <div className="site-container">
        <h2 id="final-title" className="section-title" data-testid="final-invitation-title">{finalInvitation.heading}</h2>
        <p data-testid="final-invitation-copy">{finalInvitation.copy.map((line) => <span className="copy-line" key={line}>{line}</span>)}</p>
        <a className="primary-link primary-link--light" href={finalInvitation.cta.destination} data-testid="final-primary-cta">
          {finalInvitation.cta.label} <ArrowRight size={17} aria-hidden="true" />
        </a>
      </div>
    </section>
  );
};